import viewTimesheetGroupComponentUrl from './viewTimesheetGroupComponent.html';

class ViewTimesheetGroupCtrl {
  constructor(Utils, TimesheetsUtils, GoogleMapsService, toTimeFilter) {
    'ngInject';

    Object.assign(this, { Utils, TimesheetsUtils, GoogleMapsService, toTimeFilter });
  }

  $onInit() {
    const clockIn = this.timesheetEntries.find(this.TimesheetsUtils.isClockIn);
    const clockOut = this.timesheetEntries.find(this.TimesheetsUtils.isClockOut);
    this.startDate = clockIn?.timestamp ? new Date(clockIn.timestamp) : undefined;
    this.endDate = clockOut?.timestamp ? new Date(clockOut.timestamp) : undefined;

    this.clockInCoordinates = clockIn?.coordinates;
    this.clockOutCoordinates = clockOut?.coordinates;

    this.breaks = this._getBreaks();
  }

  get totalBreakMinutes() {
    const durations = this.breaks.map((b) => b.durationMinutes);
    return Math.floor(this.Utils.sum(durations));
  }

  get now() {
    return this.Utils.getNowDate();
  }

  get boundaryEndTime() {
    return this.endDate ? `${this.toTimeFilter(this.endDate)}` : 'in progress';
  }

  get clockedInMinutes() {
    const end = this.endDate || this.now;

    return Math.floor(this.Utils.subtractDates(end, this.startDate) / 1000 / 60);
  }

  _getBreakObject(start, end, startTimesheet, endTimesheet) {
    return {
      breakStart: start && new Date(start),
      breakEnd: end && new Date(end),
      startTimesheet,
      endTimesheet,
      get durationMinutes() {
        if (this.breakStart && this.breakEnd) {
          return Math.floor((this.breakEnd - this.breakStart) / 1000 / 60);
        }

        return 0;
      },
    };
  }

  _getBreaks() {
    let previousTimesheet;
    return [...this.timesheetEntries, {}]
      .map((timesheet) => {
        let breakObject = null;

        if (previousTimesheet && this.TimesheetsUtils.isBreakStart(previousTimesheet)) {
          breakObject = this._getBreakObject(
            previousTimesheet.timestamp,
            timesheet?.timestamp,
            previousTimesheet,
            this.TimesheetsUtils.isBreakEnd(timesheet) ? timesheet : null
          );
        }

        previousTimesheet = timesheet;
        return breakObject;
      })
      .filter(Boolean);
  }
}

export default {
  bindings: {
    event: '<',
    timesheetEntries: '<',
    showTotalDifference: '<?',
  },
  templateUrl: viewTimesheetGroupComponentUrl,
  controllerAs: 'ctrl',
  controller: ViewTimesheetGroupCtrl,
};
